import React from 'react';
import s from '../ProductItem.scss';
import classNames from 'classnames';
import type {IProduct} from '../../../../types/galleryTypes';
import {withGlobals} from '../../../../globalPropsContext';
import {withTranslations} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {IGalleryGlobalProps} from '../../../../gallery/galleryGlobalStrategy';
import {
  classes as productDiscountRuleNameStylable,
  st as productDiscountRuleNameStyles,
} from './ProductDiscountRuleName.st.css';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {isProductUnavailable, shouldRenderOutOfStock, shouldRenderPrice} from '../productItemUtils';
import {Experiments} from '../../../../constants';

export enum DiscountRuleNameDataHook {
  Root = 'product-discount-rule-name',
}

export interface IDiscountRuleNameProps extends IGalleryGlobalProps {
  product: IProduct;
}

class DiscountRuleName extends React.Component<IDiscountRuleNameProps> {
  public render() {
    const {
      product,
      globals: {shouldShowMobile, allowFreeProducts, useExperiments, productsManifest},
    } = this.props;

    if (isProductUnavailable(productsManifest[product.id])) {
      return null;
    }
    const classes = classNames(
      productDiscountRuleNameStyles(productDiscountRuleNameStylable.discountNameRoot, {
        useMobileFont: shouldShowMobile,
      }),
      s.productDiscountRuleName
    );
    const shouldAddDiscountsToVariantsGallery = useExperiments.enabled(Experiments.AddDiscountsToVariantsItemsQueries);
    const discountRuleName = shouldAddDiscountsToVariantsGallery
      ? product.itemDiscount?.automaticDiscountRuleNames?.slice(0, 2).join(' \u00B7 ')
      : product.itemDiscount?.discountRuleName;
    const shouldRenderPriceLayout = shouldRenderPrice(product, allowFreeProducts);
    const shouldRenderOutOfStockLayout = shouldRenderOutOfStock(product);
    const shouldRenderDiscountRuleName = discountRuleName && (shouldRenderOutOfStockLayout || shouldRenderPriceLayout);

    if (shouldRenderDiscountRuleName) {
      return (
        <Text className={classes} data-hook={DiscountRuleNameDataHook.Root}>
          {discountRuleName}
        </Text>
      );
    }
    return null;
  }
}

export const ProductDiscountRuleName = withGlobals(withTranslations()(DiscountRuleName));
